module.exports = __webpack_public_path__ + "img/rotation_img.b29a1c19.png";